import { useState, useEffect, useRef } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/sections/SectionsAction";
import { getGradeOptions, redirectToPages, resultAlert } from "../../../../../../_helpers/Helpers";
import { 
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { SectionEditForm } from "./SectionEditForm";

export function SectionEdit({
  history,
  match: {
    params: { id }
  }
}) {
  const [title, setTitle] = useState("");
  const [gradeOptions, setGradeOptions] = useState([]);
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, section } = useSelector(
    (state) => ({
      actionsLoading: state.sections.actionsLoading,
      isSuccess: state.sections.isSuccess,
      type: state.sections.type,
      section: state.sections.section
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getSection(id));
    return () => dispatch(actions.cleanSectionsState());
  }, [id, dispatch]);
  
  useEffect(() => {
    let _title = "Şube";
    let action = id ? "Düzenle" : "Ekle";
    _title += " " + action;
    setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    setGradeOptions(getGradeOptions(section.gradeLevel));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [section && section.gradeLevel]);
  
  /** Belli Bir Şubeyi Kaydeder */
  const saveSection = (values) => {
    dispatch(actions.saveSection(values)).then((result) => onResult(result));
  };
  
  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push("/subeler"), 2500);
  };

  const btnRef = useRef();  
  const saveSectionClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title} />
      <CardBody>
        <div className="mt-5">          
          <SectionEditForm
            gradeOptions={gradeOptions}
            section={section}
            btnRef={btnRef}
            setGradeOptions={setGradeOptions}            
            saveSection={saveSection}
          />
        </div>
      </CardBody>
      <CardFooter>
        <div className="offset-sm-2">          
          <button
            type="submit"
            className="btn btn-primary"
            onClick={saveSectionClick}
          >
            Kaydet
          </button>          
        </div>
      </CardFooter>
    </Card>
  );
}